import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Button, { ButtonProps } from 'src/components/Button/Button'
import MoreDropdown, {
  MoreDropdownDesigns,
  MoreDropdownProps,
} from 'src/components/MoreDropdown/MoreDropdown'
import { css } from 'styled-components'

interface ButtonAndMoreDropdownProps {
  className?: string
  buttonProps: ButtonProps
  moreDropdownProps: MoreDropdownProps
}

const ButtonAndMoreDropdown: React.FC<ButtonAndMoreDropdownProps> = (props) => {
  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        border-radius: 10px;
        height: 38px;
      `}
      className={props.className}
    >
      <Button
        css={css`
          border: 1px solid #dadbe0;
          border-radius: 10px 0 0 10px;
          background-color: ${styleConstants.colors.gray_light};
          &:hover {
            background-color: ${styleConstants.colors.gray_medium};
          }
        `}
        {...props.buttonProps}
      />
      <MoreDropdown
        css={css`
          border: 1px solid #dadbe0;
          border-left: none;
          border-radius: 0 10px 10px 0;
          height: 38px;
          background-color: ${styleConstants.colors.gray_light};
          padding: 0px 8px;
          &:hover {
            background-color: ${styleConstants.colors.gray_medium};
          }
        `}
        {...props.moreDropdownProps}
        design={
          props.moreDropdownProps.design || MoreDropdownDesigns.WhiteToCta
        }
      />
    </div>
  )
}

export default ButtonAndMoreDropdown
